import { getCookie } from 'PlugAndPlay/_global/js/cookieHelper';
import changeRegion, { getCurrentRegion } from '../../_global/js/regions';
import { Modal } from '../../modal/js/global';

const REGION_MODAL_WRAPPER_SELECTOR = '[data-component="location-modal"]';
const REGION_CLOSE_TRIGGER = '[data-action=close]';
const REGION_MODAL_CHECK_MODAL = 'check-location-cookie';
const REGION_MODAL_SET_MODAL = 'set-location-cookie';
const REGION_MODAL_ACTIVATE_LOCATION_FINDER_BUTTON_SELECTOR =
    '.location-modal__activate';
const REGION_MODAL_DEACTIVATE_LOCATION_FINDER_BUTTON_SELECTOR =
    '.location-modal__deactivate';

export default function _locationModal() {
    // const locationWrapper = document.querySelector(REGION_WRAPPER_SELECTOR);

    class LocationModal extends Modal {
        constructor(modalWrapper) {
            super(modalWrapper);

            modalWrapper
                .querySelectorAll(REGION_CLOSE_TRIGGER)
                .forEach((closeBtn) => {
                    closeBtn.addEventListener('click', () => {
                        this.closeModal();
                    });
                });

            // Attach event handlers to activate location finder
            modalWrapper
                .querySelectorAll(
                    REGION_MODAL_ACTIVATE_LOCATION_FINDER_BUTTON_SELECTOR
                )
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.activateLocationFinder();
                    });
                });

            // Attach event handlers to deactivate location finder
            modalWrapper
                .querySelectorAll(
                    REGION_MODAL_DEACTIVATE_LOCATION_FINDER_BUTTON_SELECTOR
                )
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.deactivateLocationFinder();
                    });
                });
        }

        openModal() {
            this.modal.hidden = false;
        }

        closeModal() {
            this.modal.hidden = true;
        }

        activateLocationFinder() {
            this.modalWrapper
                .querySelectorAll(
                    '.location-modal__buttons, .location-modal__suggest'
                )
                .forEach((element) => {
                    element.classList.add('hidden');
                });
            this.modalWrapper
                .querySelectorAll('.location-modal__finder')
                .forEach((element) => {
                    element.classList.remove('hidden');
                });
        }

        deactivateLocationFinder() {
            this.modalWrapper
                .querySelectorAll(
                    '.location-modal__buttons, .location-modal__suggest'
                )
                .forEach((element) => {
                    element.classList.remove('hidden');
                });
            this.modalWrapper
                .querySelectorAll(
                    '.location-modal__finder, .location-modal__change, .location-modal__close'
                )
                .forEach((element) => {
                    element.classList.add('hidden');
                });
            this.modalWrapper.querySelector(
                '.autocomplete-location__results'
            ).innerHTML = '';
        }
    }

    const modals = document.querySelectorAll(REGION_MODAL_WRAPPER_SELECTOR);
    const regionCookie = getCookie('region-cookie');
    const currentRegion = getCurrentRegion();
    const currentURL = window.location.href;

    modals.forEach((modal) => {
        // Create a new item to modify
        const DOMItem = modal;

        // Attach the modal instance to our DOM Item
        if (!DOMItem.modal) {
            DOMItem.modal = new LocationModal(modal);

            if (currentURL.indexOf('8080') <= -1) {
                if (DOMItem.classList.contains(REGION_MODAL_SET_MODAL)) {
                    if (!regionCookie) {
                        DOMItem.modal.openModal();
                    } else if (
                        currentRegion !== 'seq' &&
                        currentRegion !== 'qld'
                    ) {
                        changeRegion(regionCookie);
                    }
                }

                if (
                    DOMItem.classList.contains(REGION_MODAL_CHECK_MODAL) &&
                    regionCookie &&
                    currentRegion !== regionCookie
                ) {
                    DOMItem.modal.openModal();
                    document
                        .querySelector('.header-location-wrapper__toggle')
                        .focus();
                }
            }
        }
    });
}

_locationModal();
